module.exports = __webpack_public_path__ + "static/media/create-initiatives.e9d258b5.svg";